export type AdvancedTableColumnSelectorHost = {
  openColumnSelector(buttonElement?: HTMLElement): void;
};

export function resolvePrimeColumnConfigButton(
  event: Event,
): HTMLElement | null {
  const target = event.target as HTMLElement | null;
  if (!target) return null;
  const pButton = target.closest('p-button');
  if (pButton) {
    return pButton.querySelector('button') as HTMLElement | null;
  }
  return (target.closest('button') as HTMLElement) || target;
}

export function openAdvancedTableColumnSelector(
  table: AdvancedTableColumnSelectorHost | undefined,
  event: Event,
): void {
  const button = resolvePrimeColumnConfigButton(event);
  if (button && table) {
    table.openColumnSelector(button);
  }
}
